import React, { Component } from 'react';

import './Keyboard.css'

var KeyType = {
  BLACK: {
    fill: 'black',
    width: 15,
    height: 80
  },
  WHITE: {
    fill: 'white',
    width: 25,
    height: 120
  }
}

var SINGLE_OCTAVE_LAYOUT = [
  KeyType.WHITE, 
  KeyType.BLACK, 
  KeyType.WHITE, 
  KeyType.BLACK, 
  KeyType.WHITE, 
  KeyType.WHITE,
  KeyType.BLACK, 
  KeyType.WHITE, 
  KeyType.BLACK, 
  KeyType.WHITE,
  KeyType.BLACK, 
  KeyType.WHITE
  ]

class Keyboard extends Component {

  makeRect(rectData) {
    const fill = (rectData.active ? 'red' : rectData.keyData.fill)
    return <rect key={rectData.x} style={{fill: fill, stroke:'black'}} x={rectData.x.toString()} y="0" width={rectData.keyData.width} height={rectData.keyData.height}/>
  }

  getRects(activeKeys) {
    
    var whiteRects = []
    var blackRects = []
    var curWhiteX = 0

    // key data has 3 octaves worth of keys
    var layout = SINGLE_OCTAVE_LAYOUT.concat(SINGLE_OCTAVE_LAYOUT).concat(SINGLE_OCTAVE_LAYOUT)

    // calculate key x position and active value
    for (var i = 0; i < layout.length; i++) {
      
      var curKey = layout[i]
      
      var x = curWhiteX

      if (curKey === KeyType.BLACK) {
        x -= (KeyType.BLACK.width / 2)
      }

      var rectData = {keyData: curKey, x: x, active: activeKeys[i]}

      if (curKey === KeyType.BLACK) {
        blackRects.push(rectData)
      } else {
        whiteRects.push(rectData)
      }

      if (curKey === KeyType.WHITE) {
        curWhiteX += curKey.width  
      }
    }

    // svg z-index is controlled by draw order. therefore we want to draw the black keys
    // after the white keys
    return whiteRects.concat(blackRects).map((rectData) => this.makeRect(rectData))
  }

  render() {
    const rects = this.getRects(this.props.activeKeys)

    return (
      <div className="keyboard">
         <svg  width="600" height="120">
          {rects}
        </svg>
      </div>
    )
  }
}

export default Keyboard;


// WEBPACK FOOTER //
// ./src/Keyboard.js